import { Loader } from '@googlemaps/js-api-loader';

const { VITE_GOOGLE_MAPS_API_KEY: API_KEY } = import.meta.env;

export const loadGoogleMapsApi = async () => {
  if (!API_KEY) {
    throw new Error('API key is required');
  }

  try {
    const loader = new Loader({
      apiKey: API_KEY,
      version: 'weekly',
      libraries: ['places']
    });

    return await loader.importLibrary('places');
  } catch (error) {
    console.error('Failed to load Google Maps API:', error);
    throw new Error('Failed to load Google Maps API. Please try again later.');
  }
};
